// ── KPI Stats ───────────────────────────────────────────
export const kpiStats = [
  { id: 'revenue',    label: 'Total Revenue',    value: '$128.4K', change: '+18.2%', up: true,  color: '#4F46E5', colorGlow: 'rgba(79,70,229,0.18)' ,variant: 'indigo'},
  { id: 'users',      label: 'Active Users',     value: '24,892',  change: '+9.4%',  up: true,  color: '#06B6D4', colorGlow: 'rgba(6,182,212,0.15)' ,variant: 'cyan'},
  { id: 'conversion', label: 'Conversion Rate',  value: '3.84%',   change: '-0.3%',  up: false, color: '#F59E0B', colorGlow: 'rgba(245,158,11,0.15)' ,variant: 'amber'},
  { id: 'uptime',     label: 'System Uptime',    value: '99.97%',  change: '+0.02%', up: true,  color: '#10B981', colorGlow: 'rgba(16,185,129,0.15)' ,variant: 'green'},
]

// ── Revenue chart ────────────────────────────────────────
export const revenueChartData = {
  labels:  ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
  revenue: [42, 58, 51, 67, 72, 89, 95, 103, 88, 112, 119, 128],
  target:  [50, 55, 60, 65, 70, 75, 80, 90,  95, 100, 110, 120],
}

// ── User chart ───────────────────────────────────────────
export const userChartData = {
  labels:      ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'],
  newUsers:    [320, 450, 380, 520, 610, 840, 720],
  activeUsers: [1800,2100,1950,2400,2700,3200,2900],
}

// ── Recent transactions ──────────────────────────────────
export const recentTransactions = [
  { id:'TXN-8841', user:'Sarah Mitchell', plan:'Enterprise', amount:'$299/mo', status:'success', date:'2 min ago' },
  { id:'TXN-8840', user:'James Holloway', plan:'Pro',        amount:'$79/mo',  status:'success', date:'18 min ago' },
  { id:'TXN-8839', user:'Priya Sharma',   plan:'Starter',   amount:'$19/mo',  status:'pending', date:'45 min ago' },
  { id:'TXN-8838', user:'Luca Martini',   plan:'Enterprise', amount:'$299/mo', status:'failed',  date:'1 hr ago' },
  { id:'TXN-8837', user:'Emily Chen',     plan:'Pro',        amount:'$79/mo',  status:'success', date:'2 hr ago' },
  { id:'TXN-8836', user:'John Martinez',  plan:'Pro',        amount:'$199/mo',  status:'success', date:'5 hr ago' },
]

// ── Activity feed ────────────────────────────────────────
export const activityFeed = [
  { type:'user',    msg:'New enterprise signup: Acme Corp (250 seats)',          time:'2 min ago',  color:'#4F46E5' },
  { type:'system',  msg:'Scheduled backup completed successfully (2.4 GB)',      time:'14 min ago', color:'#10B981' },
  { type:'warning', msg:'API rate limit reached for workspace #4421',            time:'32 min ago', color:'#F59E0B' },
  { type:'user',    msg:'Admin password reset: james.h@example.com',             time:'1 hr ago',   color:'#06B6D4' },
  { type:'system',  msg:'SSL certificate renewed for api.domain.com (90 days)',  time:'3 hr ago',   color:'#10B981' },
  { type:'error',   msg:'Payment gateway timeout — Stripe webhook retry queued', time:'4 hr ago',   color:'#EF4444' },
]

// ── Plan distribution ────────────────────────────────────
export const topPlans = [
  { name:'Enterprise', users:1240,  revenue:'$370.6K', pct:100, color:'#4F46E5' },
  { name:'Pro',        users:4880,  revenue:'$385.5K', pct:88,  color:'#06B6D4' },
  { name:'Starter',    users:9210,  revenue:'$175.0K', pct:57,  color:'#10B981' },
  { name:'Free',       users:9562,  revenue:'$0',      pct:20,  color:'#475569' },
]
